import moment, { Moment } from 'moment';
import { FC } from 'react';

type Props = {
  timestamp: Moment;
};
export const isSameCentury = (date: Moment) =>
  Math.floor(date.get('year') / 100) === Math.floor(moment().get('year') / 100);
export const isSameYear = (date: Moment) => moment().isSame(date, 'year');
export const humaiseYear = (date: Moment) =>
  isSameYear(date)
    ? ''
    : isSameCentury(date)
    ? date.format('YY')
    : date.format('YYYY');

export const humanise = (
  date: Moment,
  showYear = false,
  showApostrophe = false,
): string =>
  date.format(
    `DD MMM${
      !moment().isSame(date, 'year') || showYear
        ? isSameCentury(date)
          ? ` ${showApostrophe ? "'" : ''}YY`
          : ' YYYY'
        : ''
    }`,
  );

export const humaniseWithTime = (date: Moment): string => {
  return date.format(
    `DD MMM${
      !moment().isSame(date, 'year')
        ? isSameCentury(date)
          ? ' YY'
          : ' YYYY'
        : ''
    } HH:mm`,
  );
};

export const humaniseElapsedTime = (date: Moment): string => {
  return moment(date).fromNow();
};

export const HumanisedDate: FC<Props> = ({ timestamp }) => (
  <>{humanise(timestamp)}</>
);

export const humaniseWithDay = (date: Moment): string =>
  date.format(
    `ddd DD MMM${
      !moment().isSame(date, 'year')
        ? isSameCentury(date)
          ? ' YY'
          : ' YYYY'
        : ''
    }`,
  );

export const HumanisedDateAndTime: FC<Props> = ({ timestamp }) => {
  return <>{humaniseWithTime(timestamp)}</>;
};

export const HumaniseElapsedTime: FC<Props> = ({ timestamp }) => {
  return <>{humaniseElapsedTime(timestamp)}</>;
};
